const BusinessAreaWareHouse = {

    // FIELDS
    "business_area": "Business Area",
    "name": "Name",
    "short_name": "Short Name",
    "address": "Address",
    "postal_code": "Postal Code",
    "email": "Email",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "ware_house": "Ware House",

    // ERROR
    "error_business_area": "Select Business Area",
    "error_name": "Enter Name",
    "error_short_name": "Enter Short Name",
    "error_address": "Enter Address",
    "error_email": "Enter Email",
    "error_postal_code": "Enter Postal Code",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_email": "EMAIL",
    "table_area": "AREA",
    "table_status": "Status",
}

export default BusinessAreaWareHouse;